export default __webpack_public_path__ + "d80107c.png";